const API_BASE = process.env.REACT_APP_API_URL || '';

export async function getDerivedFields(orgId, profileId) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/report-profiles/${profileId}/derived-fields`, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    throw new Error('Failed to fetch derived fields');
  }
  
  return response.json();
}

export async function getDerivedField(orgId, profileId, fieldId) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/report-profiles/${profileId}/derived-fields/${fieldId}`, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    if (response.status === 404) {
      throw new Error('Derived field not found');
    }
    throw new Error('Failed to fetch derived field');
  }
  
  const data = await response.json();
  return data.derivedField;
}

export async function createDerivedField(orgId, profileId, data) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/report-profiles/${profileId}/derived-fields`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'x-org-id': orgId
    },
    body: JSON.stringify(data)
  });
  
  if (!response.ok) {
    const result = await response.json().catch(() => ({}));
    if (result.error) {
      throw new Error(result.error);
    }
    throw new Error('Failed to create derived field');
  }
  
  const result = await response.json();
  return result.derivedField;
}

export async function updateDerivedField(orgId, profileId, fieldId, updates) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/report-profiles/${profileId}/derived-fields/${fieldId}`, {
    method: 'PATCH',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'x-org-id': orgId
    },
    body: JSON.stringify(updates)
  });
  
  if (!response.ok) {
    const result = await response.json().catch(() => ({}));
    if (result.error) {
      throw new Error(result.error);
    }
    throw new Error('Failed to update derived field');
  }
  
  const result = await response.json();
  return result.derivedField;
}

export async function deleteDerivedField(orgId, profileId, fieldId) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/report-profiles/${profileId}/derived-fields/${fieldId}`, {
    method: 'DELETE',
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    throw new Error('Failed to delete derived field');
  }
  
  return response.json();
}

export async function validateExpression(orgId, profileId, expression) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/report-profiles/${profileId}/derived-fields/validate`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'x-org-id': orgId
    },
    body: JSON.stringify({ expression })
  });
  
  if (!response.ok) {
    throw new Error('Failed to validate expression');
  }
  
  return response.json();
}
